import './App.css';
import React, { useState } from 'react'
import Logo from './components/Logo';
import Info from './components/Info';
import Input from './components/Input';
import Footer from './components/Footer';
import Results from './components/Results';



function App() {
  // Pass down the value of the parent component 
  const [movies, setMovies] = useState([]);
  const [error, setError] = useState(false);
 


  // the parameter of this function will be the list/map of filtered movies once we get them
  const addToResults = (filteredMovies) => {
    // we will update our "movies" variable to be the list/map of filtered movies
   
    if (filteredMovies === -1){
      setMovies([-1]);
      setError(true)
    } else {
      setMovies(filteredMovies);
      setError(false);
    }
   
  }
  

  
  // default the results as an error message
  let results = <div className="results error_message" id="error_message"> <p >No films/shows</p>
    </div>
 
  const getResults = () => {
  
      // console.log(`movies is ${movies[0].id}`);
      results = movies.map((movie) => {
       // document.getElementById("footer").style.position = "relative";
       // document.getElementById("footer").style.bottom = "none";
      
       let final = false;
       if (movie.id === movies[movies.length-1].id){
         final = true;
       }
         return <Results 
                 title = { movie.original_title }
                 poster = { movie.poster_path}
                 description = {movie.overview}
                 actor1 = {movie.actorName}
                 actor1Character = {movie.character}
                 actor2 = {movie.secondActorName}
                 actor2Character = {movie.secondCharacterName}
                 key = {movie.id}
                 id = {movie.id}
                 final = {final}
                 />
     })
    
   return results
  }

 

 
  return (
    <div className="App">
      <div className="content" id="content">
        <div className="header">
          <Logo/>
          { movies.length === 0 ? <Info/> : null}
        </div>
        <Input parentFunction={addToResults}/>
         
          { (movies.length > 0  && error === true) ? results : getResults()}

        <Footer/>
      </div>
      {/* generate name for background image */}
    </div>
  );
}

export default App;
